import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
// ----------------------------------------------------------------------

// const RedAsteriskTextField = styled(TextField)({
//   '& .MuiInputLabel-asterisk': {
//     color: 'red', // Set the asterisk color to red
//   },
// });
const RedAsteriskTextField = styled(TextField)(() => ({
  // Label text
  '& .MuiInputLabel-root': {
    color: 'white',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white', // prevent it from turning blue
  },

  // Asterisk in label (e.g., required fields)
  '& .MuiInputLabel-asterisk': {
    color: 'red',
  },
  // Input text
  '& .MuiInputBase-input': {
    color: 'white',
  },
  // Outlined variant border color
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '&:hover fieldset': {
      borderColor: 'white',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
    },
  },
  // Helper text color
  '& .MuiFormHelperText-root': {
    color: '#ccc',
  },
}));
export default function RHFTextField({
  name,
  required,
  size = 'small',
  helperText,
  shrink,
  type,
  multiline,
  rows,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <RedAsteriskTextField
          {...field}
          fullWidth
          size={size}
          type={type}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={(event) => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error ? error?.message?.toLowerCase() : helperText}
          InputLabelProps={{
            shrink,
            required,
          }}
          multiline={multiline}
          rows={rows}
          {...other}
        />
      )}
    />
  );
}

RHFTextField.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.string,
  shrink: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};
